/* POSH — تنسيق السعر: 22.500 تبقى 22.5 و18.000 تبقى 18 و76.500 تبقى 76.5 */
(function () {
  'use strict';

  var THREE = new RegExp('^[0-9]+[.][0-9]{3}$');
  var MONEY = new RegExp('[0-9]{1,3}(?:,[0-9]{3})*[.][0-9]{3}(?![0-9])', 'g');

  function trim(match) {
    var n = match.replace(/,/g, '');
    if (!THREE.test(n)) return match;
    var out = n.replace(/0+$/, '').replace(/[.]$/, '');
    if (match.indexOf(',') > -1) {
      var parts = out.split('.');
      parts[0] = parts[0].replace(/\B(?=([0-9]{3})+(?![0-9]))/g, ',');
      out = parts.join('.');
    }
    return out;
  }

  function fixNode(node) {
    var v = node.nodeValue;
    if (!v || v.indexOf('.') === -1) return;
    var out = v.replace(MONEY, trim);
    if (out !== v) node.nodeValue = out;
  }

  function scan(root) {
    if (!root) return;
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'KWD';
    if (cur !== 'KWD') return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        if (p.closest('input, textarea, select')) return NodeFilter.FILTER_REJECT;
        return n.nodeValue && n.nodeValue.indexOf('.') > -1 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var n;
    while ((n = walker.nextNode())) fixNode(n);
  }

  function run() { scan(document.body); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; run(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('cart:update', function () { setTimeout(run, 300); });
  document.addEventListener('shopify:section:load', run);
})();